var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormulateInput',{attrs:{"label":_vm.translate('header.language'),"value":_vm.getCurrentLang,"options":_vm.langs,"type":"select","placeholder":"Select an language"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }